import { LocalStorageKey } from '@/lib/storageConstants'

export const logout = () => {
    window.localStorage.removeItem(LocalStorageKey.JWT)
}
